import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=65230c28&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=ts"
export * from "./PopupDialog.vue?vue&type=script&lang=ts"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=65230c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65230c28",
  null
  
)

export default component.exports